import { useSettings } from "api/general";
import { Breadcrumbs, TopHeader } from "components/Header/TopHeader/TopHeader";
import { useMessage } from "hooks/intl";
import "react-loading-skeleton/dist/skeleton.css";
import { useParams } from "react-router-dom";
import { links } from "utilities/links";
import { AdminForm } from "./AdminForm";
import { useStyles } from "./AdminForm.styles";

export function EditAdmin() {
  const classes = useStyles();
  const { useAdminData } = useSettings();
  const { id: adminID } = useParams<{ id: string }>();
  const { data: adminData } = useAdminData(adminID);
  const { message } = useMessage();

  const breadcrumbs: Breadcrumbs = {
    parent: {
      label: message({ id: "admins" }),
      path: links.settings,
      state: {
        state: { activeTab: "admins" },
      },
    },
  };

  return (
    <>
      <TopHeader
        breadcrumbs={breadcrumbs}
        clearLink={links.settings}
        title={
          adminData
            ? `${message({ id: "editAdmin" })} "${
                adminData.firstName || adminData.lastName
                  ? [adminData.firstName, adminData.lastName]
                      .filter(Boolean)
                      .join(" ")
                  : adminData.email || adminData.id
              }"`
            : ""
        }
      />
      <div className={classes.formWrapper}>
        <AdminForm editMode initialValues={adminData} />
      </div>
    </>
  );
}
